import React, { Component } from 'react';
import { SubHeader, SubHeaderText } from './styles';

class Title extends Component {
    constructor(props){
        super(props)
    }

    render() {
        return (
            <SubHeader>
                <SubHeaderText>
                    {this.props.children != undefined ?
                        this.props.children :
                        <p>Após concluir todos os passos, seu <strong>pedido deverá ser encaminhado ao cliente para aprovação final</strong></p>
                    }
                </SubHeaderText>
            </SubHeader>
        );
    }
}

export default Title;
